export type MarginArgs = {
  amount?: number;
};

/**
 * @deprecated
 * js/src/domain/margin2.ts を使用すること
 */
class Margin {
  amount = 0;

  constructor(args: MarginArgs) {
    Object.assign(this, utils.snakeToCamelObject(args));
  }

  setAmount(value: number) {
    this.amount = value;
    app.render();
  }

  updateParams() {
    return { amount: this.amount };
  }
}

export default Margin;
